/* eslint-disable */

$(document).ready(function () {

  $(".video-custom").on('click', function () {
    var video = $(".video-responsive iframe");
    $(".video-responsive img").delay(500).fadeOut(500);
    $(".video-overlay").delay(500).fadeOut(500);
    $(this).fadeOut(500, function () {
    video.attr("src", video.data("autoplay-src"));
    });
  });
  $(".video-overlay").on('click', function () {
    var video = $(".video-responsive iframe");
    $(".video-custom").delay(200).fadeOut(200);
    $(".video-responsive img").delay(300).fadeOut(300);
    $(this).fadeOut(500, function () {
      video.attr("src", video.data("autoplay-src"));
    });
  });
});
